var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout":_vm.snackTime},model:{value:(_vm.snackP),callback:function ($$v) {_vm.snackP=$$v},expression:"snackP"}},[_vm._v("\n  "+_vm._s(_vm.snackText)+"\n  ")])
}
var staticRenderFns = []

export { render, staticRenderFns }